
export default {
  async asyncData({ $getContent }) {
    return {
      partners: await $getContent('partners'),
    }
  },
  head: {
    title: 'Partners',
  },
}
